import { Component, Input } from '@angular/core';
import { CplUserRequest } from 'src/app/model/cpl-user-request.model';
import { DEFAULT_USER_REQUEST_MANAGING_USER_ICON_CONFIG } from './const/default-user-request-managing-user-icon-config.model';
import { UserRequestManagingUserIconConfig } from './interface/user-request-managing-user-icon-config.model';

@Component({
    selector: 'user-request-managing-user-icon',
    templateUrl: './user-request-managing-user-icon.component.html',
    styleUrls: ['./user-request-managing-user-icon.component.scss']
})
export class UserRequestManagingUserIconComponent {
    @Input() userRequest: CplUserRequest;
    @Input() innerClass: string = '';
    @Input() get config() {
        return this._config;
    } 
    
    set config(value: UserRequestManagingUserIconConfig) {
        this._config = {...DEFAULT_USER_REQUEST_MANAGING_USER_ICON_CONFIG, ...value };
    }

    private _config: UserRequestManagingUserIconConfig = DEFAULT_USER_REQUEST_MANAGING_USER_ICON_CONFIG;



}
